import { getServerDateRange } from "../../hooks/timezone/serverDate";
import { useGetSettings } from "../../hooks/timezone/settings.hooks";
import { ButtonGroup } from "../index.js";

function DateButtonGroup({ dateOptions, chosenDate, setChosenDate, setDate }) {
  const { data: setting } = useGetSettings({ options: {} });
  const serverTimezone = setting?.timezone;

  const onChange = (type) => {
    if (!serverTimezone) return;

    setChosenDate(type);
    setDate(getServerDateRange(type, serverTimezone));
  };
  return (
    <ButtonGroup
      options={dateOptions}
      chosenVal={chosenDate}
      setChosenVal={setChosenDate}
      amountInOneRow={3}
      buttonOnChange={onChange}
    />
  );
}

export default DateButtonGroup;
